import React, { useState } from 'react';
import { Activity, AlertCircle, CalendarClock, CheckCircle2, ExternalLink, ListChecks, XCircle, LayoutGrid, Server } from 'lucide-react';
import ModalShell from '../ModalShell';

function isPlannedStatus(maintenanceInfo) {
  return maintenanceInfo?.kind === 'scheduled';
}

function getStatusPresentation(maintenanceInfo) {
  if (maintenanceInfo === null || maintenanceInfo?.error) {
    return {
      bgClass: 'bg-gray-50 dark:bg-gray-900/20 border-gray-200 dark:border-gray-900/40',
      icon: AlertCircle,
      iconClass: 'text-gray-400 dark:text-gray-500',
      text: 'Não foi possível obter as informações de status deste serviço no momento.',
      textClass: 'text-gray-500 dark:text-gray-400',
      title: 'Falha na Consulta',
      titleClass: 'text-gray-500 dark:text-gray-400',
      warning: 'Erro'
    };
  }

  if (maintenanceInfo.status === 'operational') {
    return {
      bgClass: 'bg-emerald-50 dark:bg-emerald-900/20 border-emerald-200 dark:border-emerald-900/40',
      icon: CheckCircle2,
      iconClass: 'text-emerald-600 dark:text-emerald-400',
      text: maintenanceInfo?.text || 'Nenhuma instabilidade ou manutenção identificada no serviço.',
      textClass: 'text-emerald-700/80 dark:text-emerald-200/60',
      title: maintenanceInfo?.title || 'Serviço Operacional',
      titleClass: 'text-emerald-600 dark:text-emerald-400',
      warning: maintenanceInfo?.warning || ''
    };
  }

  if (isPlannedStatus(maintenanceInfo)) {
    return {
      bgClass: 'bg-sky-50 dark:bg-sky-900/20 border-sky-200 dark:border-sky-900/40',
      icon: CalendarClock,
      iconClass: 'text-sky-600 dark:text-sky-400',
      text: maintenanceInfo.text,
      textClass: 'text-sky-700/80 dark:text-sky-200/60',
      title: maintenanceInfo.title || 'Evento Agendado',
      titleClass: 'text-sky-600 dark:text-sky-400',
      warning: maintenanceInfo.warning || ''
    };
  }

  if (maintenanceInfo.status === 'outage' || maintenanceInfo.kind === 'outage' || maintenanceInfo.kind === 'timeout') {
    return {
      bgClass: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-900/40',
      icon: XCircle,
      iconClass: 'text-red-600 dark:text-red-400',
      text: maintenanceInfo.text,
      textClass: 'text-red-700/80 dark:text-red-200/60',
      title: maintenanceInfo.title || 'Serviço Indisponível',
      titleClass: 'text-red-600 dark:text-red-400',
      warning: maintenanceInfo.warning || ''
    };
  }

  return {
    bgClass: 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-900/40',
    icon: AlertCircle,
    iconClass: 'text-amber-600 dark:text-amber-400',
    text: maintenanceInfo.text,
    textClass: 'text-amber-700/80 dark:text-amber-200/60',
    title: maintenanceInfo.title || 'Aviso de Manutenção',
    titleClass: 'text-amber-600 dark:text-amber-400',
    warning: maintenanceInfo.warning || ''
  };
}

function getWebManiaStatusPresentation(status) {
  switch (status) {
    case 'OPERATIONAL':
      return {
        bgClass: 'bg-emerald-50 dark:bg-emerald-900/20 border-emerald-200 dark:border-emerald-900/40',
        icon: CheckCircle2,
        iconClass: 'text-emerald-600 dark:text-emerald-400',
        title: 'Operacional',
        titleClass: 'text-emerald-600 dark:text-emerald-400'
      };
    case 'PARTIALOUTAGE':
      return {
        bgClass: 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-900/40',
        icon: AlertCircle,
        iconClass: 'text-amber-600 dark:text-amber-400',
        title: 'Instabilidade Parcial',
        titleClass: 'text-amber-600 dark:text-amber-400'
      };
    case 'MINOROUTAGE':
      return {
        bgClass: 'bg-orange-50 dark:bg-orange-900/20 border-orange-200 dark:border-orange-900/40',
        icon: AlertCircle,
        iconClass: 'text-orange-600 dark:text-orange-400',
        title: 'Instabilidade Menor',
        titleClass: 'text-orange-600 dark:text-orange-400'
      };
    case 'MAJOROUTAGE':
      return {
        bgClass: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-900/40',
        icon: XCircle,
        iconClass: 'text-red-600 dark:text-red-400',
        title: 'Indisponibilidade Total',
        titleClass: 'text-red-600 dark:text-red-400'
      };
    default:
      return {
        bgClass: 'bg-gray-50 dark:bg-gray-900/20 border-gray-200 dark:border-gray-900/40',
        icon: AlertCircle,
        iconClass: 'text-gray-600 dark:text-gray-400',
        title: status || 'Desconhecido',
        titleClass: 'text-gray-600 dark:text-gray-400'
      };
  }
}

function getTecnoSpeedStatusPresentation(item) {
  const status = item?.status;
  const severity = item?.severity;

  if (severity === 'operational' || status === 'normal') {
    return {
      bgClass: 'bg-emerald-50 dark:bg-emerald-900/20 border-emerald-200 dark:border-emerald-900/40',
      dotClass: 'bg-emerald-500',
      icon: CheckCircle2,
      iconClass: 'text-emerald-600 dark:text-emerald-400',
      title: item?.label || 'Normal',
      titleClass: 'text-emerald-600 dark:text-emerald-400'
    };
  }

  if (severity === 'outage' || status === 'timeout' || status === 'error') {
    return {
      bgClass: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-900/40',
      dotClass: 'bg-red-500',
      icon: XCircle,
      iconClass: 'text-red-600 dark:text-red-400',
      title: item?.label || 'Erro',
      titleClass: 'text-red-600 dark:text-red-400'
    };
  }

  if (severity === 'degraded' || status === 'slow' || status === 'very_slow') {
    return {
      bgClass: 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-900/40',
      dotClass: 'bg-amber-500',
      icon: AlertCircle,
      iconClass: 'text-amber-600 dark:text-amber-400',
      title: item?.label || 'Lento',
      titleClass: 'text-amber-600 dark:text-amber-400'
    };
  }

  return {
    bgClass: 'bg-gray-50 dark:bg-gray-900/20 border-gray-200 dark:border-gray-900/40',
    dotClass: 'bg-gray-400',
    icon: AlertCircle,
    iconClass: 'text-gray-600 dark:text-gray-400',
    title: item?.label || 'Desconhecido',
    titleClass: 'text-gray-600 dark:text-gray-400'
  };
}

function renderContingencySection(title, section) {
  if (!section) return null;

  const affected = Array.isArray(section.affectedSefaz) ? section.affectedSefaz.join(', ') : '';
  const entries = Array.isArray(section.entries) && section.entries.length ? section.entries : [];

  return (
    <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white/70 dark:bg-gray-800/40 p-3">
      <p className="text-[10px] font-black uppercase tracking-widest text-gray-500 dark:text-gray-400">
        {title}
      </p>
      <p className="mt-1 text-xs font-bold text-gray-900 dark:text-white">
        {section.title || 'Contingência'}
      </p>
      <p className="mt-1 text-xs text-gray-600 dark:text-gray-300">
        {section.active
          ? `${section.contingencyType || 'Tipo não informado'}${affected ? ` • ${affected}` : ''}`
          : section.message || 'Nenhum registro ativo.'}
      </p>
      {section.active && entries.length > 0 ? (
        <div className="mt-3 space-y-2">
          {entries.map((entry, index) => {
            const entryAffected = entry.affectedSefaz || (Array.isArray(entry.affectedSefazList) ? entry.affectedSefazList.join(', ') : '');
            const period = entry.startsAt && entry.endsAt ? `De ${entry.startsAt} até ${entry.endsAt}` : '';

            return (
              <div key={`${entry.rawText || entryAffected || index}`} className="rounded-xl border border-gray-100 dark:border-gray-700 px-3 py-2">
                <p className="text-xs font-bold text-gray-900 dark:text-white">
                  {entryAffected || 'UF não informada'}
                </p>
                {period ? (
                  <p className="mt-1 text-[11px] text-gray-600 dark:text-gray-300">
                    {period}
                  </p>
                ) : null}
                {entry.contingencyType ? (
                  <p className="mt-1 text-[10px] font-black uppercase tracking-widest text-amber-700 dark:text-amber-300">
                    {entry.contingencyType}
                  </p>
                ) : null}
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}

function renderSvcRsStatus(svcRs) {
  const states = Array.isArray(svcRs?.states) ? svcRs.states : [];
  if (!states.length) return null;
  if (states.some(state => state.status === 'active' || state.status === 'scheduled')) return null;

  const buildSection = (status, title, emptyMessage) => {
    const matchingStates = states.filter(state => state.status === status);

    return {
      active: matchingStates.length > 0,
      title,
      message: matchingStates.length ? null : emptyMessage,
      contingencyType: 'SVC-RS',
      affectedSefaz: matchingStates.map(state => state.uf),
      entries: matchingStates.map(state => ({
        affectedSefaz: state.uf,
        affectedSefazList: [state.uf],
        contingencyType: 'SVC-RS',
        startsAt: state.startsAt,
        endsAt: state.endsAt,
        rawText: `${state.label} | ${state.statusText}`
      }))
    };
  };

  const activeSection = buildSection(
    'active',
    'Contingência Ativada na SVC-RS',
    'Não há estados com serviço de contingência ativo no momento.'
  );
  const scheduledSection = buildSection(
    'scheduled',
    'Contingência Agendada na SVC-RS',
    'Não há agendamentos para o serviço de contingência.'
  );

  return (
    <>
      {renderContingencySection('Contingência Ativa', activeSection)}
      {renderContingencySection('Contingência Agendada', scheduledSection)}
    </>
  );
}

function renderAffectedAuthorizers(availability) {
  const affectedAuthorizers = availability?.affectedAuthorizers || [];
  if (!affectedAuthorizers.length) return null;

  return (
    <div className="mt-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white/70 dark:bg-gray-800/40 p-3 space-y-2">
      <p className="text-[10px] font-black uppercase tracking-widest text-gray-500 dark:text-gray-400">
        Autorizadores Afetados
      </p>
      {affectedAuthorizers.map((authorizer) => (
        <div key={authorizer.authorizer} className="rounded-xl border border-gray-100 dark:border-gray-700 px-3 py-2">
          <p className="text-xs font-bold text-gray-900 dark:text-white">{authorizer.authorizer}</p>
          <p className="mt-1 text-[11px] text-gray-600 dark:text-gray-300">
            {authorizer.degradedServices.map((service) => `${service.title}: ${service.label}`).join(' • ')}
          </p>
        </div>
      ))}
    </div>
  );
}

function renderAuthorizerCoverage(availability) {
  const authorizers = availability?.authorizers || [];
  if (!authorizers.length) return null;

  return (
    <div className="mt-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white/70 dark:bg-gray-800/40 p-3 space-y-2">
      <p className="text-[10px] font-black uppercase tracking-widest text-gray-500 dark:text-gray-400">
        Cobertura dos Autorizadores
      </p>
      <div className="flex flex-wrap gap-2">
        {authorizers.map((authorizer) => {
          const serviceStates = Object.values(authorizer.services || {}).map((service) => service.status);
          const tone = authorizer.category === 'auxiliary'
            ? 'border-gray-200 bg-gray-50 text-gray-600 dark:border-gray-700 dark:bg-gray-800/40 dark:text-gray-300'
            : serviceStates.includes('outage')
            ? 'border-red-200 bg-red-50 text-red-700 dark:border-red-900/40 dark:bg-red-900/20 dark:text-red-200'
            : serviceStates.includes('unstable')
              ? 'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900/40 dark:bg-amber-900/20 dark:text-amber-200'
              : 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900/40 dark:bg-emerald-900/20 dark:text-emerald-200';

          return (
            <span
              key={authorizer.authorizer}
              className={`inline-flex rounded-full border px-2.5 py-1 text-[10px] font-black uppercase tracking-widest ${tone}`}
            >
              {authorizer.authorizer}
            </span>
          );
        })}
      </div>
    </div>
  );
}

const AMBIENTE_MAPPING = {
  'MA': 'SVAN',
  'AC, AL, AP, CE, DF, ES, MG, PA, PB, PI, RJ, RN, RO, RR, RS, SC, SE, SP, TO': 'SVC-AN',
  'AM, BA, GO, MA, MS, MT, PE, PR': 'SVC-RS',
  'AC, ES, RN, PB, SC': 'SVRS',
  'AP, PE, RR': 'SVSP',
  'AC, AL, AM, BA, CE, DF, ES, GO, MA, PA, PB, PI, RJ, RN, RO, SC, SE, TO': 'SVRS',
  'AC, AL, AP, CE, DF, ES, PA, PB, PI, RJ, RN, RO, RR, SC, SE, TO': 'SVRS'
};

function renderAvailabilityGroups(availability) {
  const groups = availability?.groups || [];
  if (!groups.length) return null;

  // Agrupar UFs por ambiente para evitar repetição de títulos
  const envGroups = {};

  groups.forEach((group) => {
    const mappedEnv = AMBIENTE_MAPPING[group.label];
    const hasValues = group.values && group.values.length > 0;
    
    let title = group.label;
    let ufsString = hasValues ? group.values.join(', ') : group.label;

    if (mappedEnv && !hasValues) {
      title = `Estados que utilizam a ${mappedEnv}`;
      ufsString = group.label;
    } else if (hasValues) {
      if (!title.toLowerCase().includes('utilizam')) {
        title = `Estados que utilizam a ${group.label}`;
      }
    }

    if (!envGroups[title]) {
      envGroups[title] = new Set();
    }

    // Adiciona as UFs ao Set do ambiente correspondente
    ufsString.split(',').forEach(uf => {
      const trimmed = uf.trim();
      if (trimmed) envGroups[title].add(trimmed);
    });
  });

  return (
    <div className="mt-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white/70 dark:bg-gray-800/40 p-3 space-y-4">
      <p className="text-[10px] font-black uppercase tracking-widest text-gray-500 dark:text-gray-400">
        UFs e Ambientes
      </p>
      {Object.entries(envGroups).map(([title, ufs]) => (
        <div key={title} className="space-y-1">
          <p className="text-xs font-bold text-gray-900 dark:text-white">
            {title}
          </p>
          <p className="text-[11px] text-gray-600 dark:text-gray-300 break-words leading-relaxed">
            {Array.from(ufs).sort().join(', ')}
          </p>
        </div>
      ))}
    </div>
  );
}

export default function ServiceStatusModal({
  isLoading,
  isLoadingWebMania,
  isLoadingTecnoSpeed,
  items,
  webManiaItems,
  webManiaError,
  tecnoSpeedItems,
  tecnoSpeedError,
  onClose
}) {
  const [activeTab, setActiveTab] = useState('sefaz');

  const groupedWebMania = React.useMemo(() => {
    if (!webManiaItems || webManiaError) return [];
    
    // Filtra os componentes que são grupos (não possuem group.id)
    const topLevelGroups = webManiaItems.filter(item => !item.group);
    
    return topLevelGroups.map(group => {
      const children = webManiaItems.filter(item => item.group?.id === group.id);
      return {
        ...group,
        children
      };
    });
  }, [webManiaItems, webManiaError]);

  const groupedTecnoSpeed = React.useMemo(() => {
    if (!tecnoSpeedItems || tecnoSpeedError) return [];

    return tecnoSpeedItems.map((item) => ({
      ...item,
      states: Array.isArray(item.states)
        ? [...item.states].sort((a, b) => String(a.uf).localeCompare(String(b.uf)))
        : []
    }));
  }, [tecnoSpeedItems, tecnoSpeedError]);

  return (
    <ModalShell
      icon={ListChecks}
      maxWidthClass="max-w-5xl"
      onClose={onClose}
      subtitle="Visão consolidada dos serviços com status disponível na API."
      themeClass="bg-teal-600"
      title="Status dos Serviços"
    >
      <div className="flex items-center justify-center py-4 px-3 bg-gray-50/50 dark:bg-gray-900/20 border-b border-gray-100 dark:border-gray-800/50">
        <div className="flex flex-wrap justify-center bg-gray-200/50 dark:bg-gray-800/50 p-1 rounded-2xl shadow-inner w-fit max-w-full">
          <button
            onClick={() => setActiveTab('sefaz')}
            className={`flex items-center justify-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all rounded-xl ${
              activeTab === 'sefaz'
                ? 'bg-white dark:bg-gray-700 text-teal-600 dark:text-teal-400 shadow-md'
                : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
            }`}
          >
            <Server size={14} />
            <span className="leading-none">Sefaz (Oficial)</span>
          </button>
          <button
            onClick={() => setActiveTab('webmania')}
            className={`flex items-center justify-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all rounded-xl ${
              activeTab === 'webmania'
                ? 'bg-white dark:bg-gray-700 text-teal-600 dark:text-teal-400 shadow-md'
                : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
            }`}
          >
            <LayoutGrid size={14} />
            <span className="leading-none">API Web Mania</span>
          </button>
          <button
            onClick={() => setActiveTab('tecnospeed')}
            className={`flex items-center justify-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all rounded-xl ${
              activeTab === 'tecnospeed'
                ? 'bg-white dark:bg-gray-700 text-teal-600 dark:text-teal-400 shadow-md'
                : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
            }`}
          >
            <Activity size={14} />
            <span className="leading-none">TecnoSpeed</span>
          </button>
        </div>
      </div>

      <div className="max-h-[70vh] overflow-y-auto p-4 sm:p-6 space-y-4 bg-gray-50 dark:bg-gray-900/30">
        {activeTab === 'sefaz' ? (
          isLoading ? (
            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
              {[1, 2, 3, 4, 5, 6].map((index) => (
                <div key={index} className="rounded-3xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-5 animate-pulse space-y-3">
                  <div className="h-4 w-28 bg-gray-200 dark:bg-gray-700 rounded" />
                  <div className="h-5 w-40 bg-gray-200 dark:bg-gray-700 rounded" />
                  <div className="h-3 w-full bg-gray-200 dark:bg-gray-700 rounded" />
                  <div className="h-3 w-5/6 bg-gray-200 dark:bg-gray-700 rounded" />
                </div>
              ))}
            </div>
          ) : (
            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
              {items.map((item) => {
                const status = getStatusPresentation(item.maintenanceInfo);
                const Icon = status.icon;

                return (
                  <div
                    key={item.id}
                    className={`rounded-3xl border p-5 shadow-sm transition-all hover:shadow-md ${status.bgClass}`}
                  >
                    <div className="flex items-start justify-between gap-3">
                      <div className="min-w-0">
                        <p className="text-[10px] font-black uppercase tracking-widest text-gray-500 dark:text-gray-400">
                          {item.id}
                        </p>
                        <h4 className="mt-1 text-base font-black text-gray-900 dark:text-white break-words">
                          {item.label}
                        </h4>
                      </div>
                      <Icon className={`h-5 w-5 shrink-0 ${status.iconClass}`} />
                    </div>

                    <p className={`mt-4 text-sm font-bold ${status.titleClass}`}>
                      {status.title}
                    </p>
                    <p className={`mt-2 text-xs leading-relaxed ${status.textClass}`}>
                      {status.text}
                    </p>

                    {status.warning ? (
                      <div className="mt-3 inline-flex rounded-full border border-black/10 dark:border-white/10 px-2.5 py-1 text-[10px] font-black uppercase tracking-widest text-gray-700 dark:text-gray-100">
                        {status.warning}
                      </div>
                    ) : null}

                    {item.maintenanceInfo?.availability ? (
                      <div className="mt-4 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white/70 dark:bg-gray-800/40 p-3 space-y-2">
                        <div className="flex items-center justify-between gap-3">
                          <p className="text-[10px] font-black uppercase tracking-widest text-gray-500 dark:text-gray-400">
                            Disponibilidade
                          </p>
                          <p className="text-[10px] font-bold text-gray-500 dark:text-gray-400">
                            {item.maintenanceInfo.availability.lastCheckedAt || '--'}
                          </p>
                        </div>
                        <p className="text-xs text-gray-700 dark:text-gray-200">
                          {item.maintenanceInfo.availability.summary?.authorizers?.operational ?? 0} operacionais,
                          {' '}
                          {item.maintenanceInfo.availability.summary?.authorizers?.unstable ?? 0} instáveis e
                          {' '}
                          {item.maintenanceInfo.availability.summary?.authorizers?.outage ?? 0} indisponíveis.
                        </p>
                        {(item.maintenanceInfo.availability.summary?.authorizers?.auxiliary ?? 0) > 0 ? (
                          <p className="text-[11px] text-gray-500 dark:text-gray-400">
                            {item.maintenanceInfo.availability.summary.authorizers.auxiliary} autorizador(es) auxiliar(es) sem serviço aplicável nesta visão.
                          </p>
                        ) : null}
                        {item.maintenanceInfo.availability.webserviceVersion ? (
                          <p className="text-[11px] text-gray-500 dark:text-gray-400">
                            Webservices v{item.maintenanceInfo.availability.webserviceVersion}
                          </p>
                        ) : null}
                      </div>
                    ) : null}

                    {(item.id === 'nfe' || item.id === 'cte') && item.maintenanceInfo?.availability
                      ? renderAffectedAuthorizers(item.maintenanceInfo.availability)
                      : null}

                    {(item.id === 'nfe' || item.id === 'cte') && item.maintenanceInfo?.availability
                      ? renderAuthorizerCoverage(item.maintenanceInfo.availability)
                      : null}

                    {(item.id === 'nfe' || item.id === 'cte') && item.maintenanceInfo?.availability
                      ? renderAvailabilityGroups(item.maintenanceInfo.availability)
                      : null}

                    {item.maintenanceInfo?.contingency ? (
                      <div className="mt-4 space-y-2">
                        {renderSvcRsStatus(item.maintenanceInfo.contingency.svcRs)}
                        {renderContingencySection('Contingência Ativa', item.maintenanceInfo.contingency.active)}
                        {renderContingencySection('Contingência Agendada', item.maintenanceInfo.contingency.scheduled)}
                      </div>
                    ) : null}

                    {item.maintenanceInfo?.source ? (
                      <div className="mt-4 rounded-2xl border border-dashed border-gray-200 dark:border-gray-700/50 px-3 py-2.5 text-[11px]">
                        <p className="font-black uppercase tracking-widest text-[9px] text-gray-400 dark:text-gray-500">
                          Portal de Origem
                        </p>
                        <div className="flex items-center justify-between gap-2 mt-1">
                          <p className="font-bold text-gray-700 dark:text-gray-300 truncate">
                            {item.maintenanceInfo.source.url?.includes('svrs') ? 'Sefaz Virtual RS' : 
                             item.maintenanceInfo.source.url?.includes('svan') ? 'Sefaz Virtual AN' :
                             'Portal SEFAZ'}
                          </p>
                          <a
                            href={item.maintenanceInfo.source.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="shrink-0 inline-flex items-center gap-1 font-black uppercase tracking-widest text-[9px] text-teal-600 dark:text-teal-400 hover:text-teal-700 dark:hover:text-teal-300 transition-colors"
                          >
                            <ExternalLink size={10} /> Link
                          </a>
                        </div>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          )
        ) : activeTab === 'webmania' ? (
          // ABA WEB MANIA
          isLoadingWebMania ? (
            <div className="space-y-6">
              {[1, 2].map((i) => (
                <div key={i} className="animate-pulse space-y-4">
                  <div className="h-6 w-48 bg-gray-200 dark:bg-gray-700 rounded-lg" />
                  <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                    {[1, 2, 3].map((j) => (
                      <div key={j} className="h-24 bg-white dark:bg-gray-800 rounded-3xl border border-gray-200 dark:border-gray-700" />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="space-y-8">
              {groupedWebMania.map((group) => (
                <div key={group.id} className="space-y-4">
                  <div className="flex items-center justify-between px-2">
                    <h3 className="text-sm font-black uppercase tracking-widest text-gray-900 dark:text-white flex items-center gap-2">
                      <div className={`h-2 w-2 rounded-full ${getWebManiaStatusPresentation(group.status).iconClass.split(' ')[0].replace('text', 'bg')}`} />
                      {group.name}
                    </h3>
                    <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${getWebManiaStatusPresentation(group.status).bgClass} ${getWebManiaStatusPresentation(group.status).titleClass}`}>
                      {getWebManiaStatusPresentation(group.status).title}
                    </span>
                  </div>
                  
                  <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    {group.children.map((child) => {
                      const presentation = getWebManiaStatusPresentation(child.status);
                      const Icon = presentation.icon;

                      return (
                        <div
                          key={child.id}
                          className={`group rounded-2xl border p-3 transition-all hover:shadow-sm ${presentation.bgClass}`}
                        >
                          <div className="flex items-center justify-between gap-2">
                            <span className="text-xs font-bold text-gray-800 dark:text-gray-200 truncate">
                              {child.name}
                            </span>
                            <Icon className={`h-3.5 w-3.5 shrink-0 ${presentation.iconClass}`} />
                          </div>
                          {child.description && (
                            <p className="mt-1 text-[10px] text-gray-500 dark:text-gray-400 truncate">
                              {child.description}
                            </p>
                          )}
                          
                          {child.activeIncidents?.length > 0 && (
                            <div className="mt-2 pt-2 border-t border-black/5 dark:border-white/5">
                              {child.status === 'OPERATIONAL' ? (
                                <a
                                  href={child.activeIncidents[0].url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex items-center gap-1 text-[9px] font-bold text-amber-600 dark:text-amber-400 hover:underline"
                                >
                                  <AlertCircle size={10} /> {child.activeIncidents.length} {child.activeIncidents.length === 1 ? 'incidente ativo' : 'incidentes ativos'}
                                </a>
                              ) : (
                                child.activeIncidents.map(incident => (
                                  <a
                                    key={incident.id}
                                    href={incident.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-1 text-[9px] font-bold text-red-600 dark:text-red-400 hover:underline mb-1 last:mb-0"
                                  >
                                    <AlertCircle size={10} /> Incidente Ativo
                                  </a>
                                ))
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}

              {webManiaError && (
                <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
                  <div className="h-12 w-12 rounded-2xl bg-red-50 dark:bg-red-900/20 flex items-center justify-center mb-4">
                    <AlertCircle className="text-red-500" size={24} />
                  </div>
                  <h4 className="text-sm font-black text-gray-900 dark:text-white uppercase tracking-widest">Falha na Consulta</h4>
                  <p className="mt-2 text-xs text-gray-500 dark:text-gray-400 max-w-xs">
                    Não foi possível carregar os dados de monitoramento da Web Mania no momento. Por favor, tente novamente mais tarde.
                  </p>
                </div>
              )}

              {groupedWebMania.length === 0 && !isLoadingWebMania && !webManiaError && (
                <div className="text-center py-12">
                  <p className="text-sm text-gray-500 dark:text-gray-400">Nenhum dado de monitoramento disponível.</p>
                </div>
              )}

              <div className="mt-8 rounded-2xl border border-dashed border-gray-300 dark:border-gray-700 p-4 text-center">
                <p className="text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest">
                  Monitoramento em tempo real via Web Mania®
                </p>
                <a
                  href="https://monitorsefaz.webmaniabr.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-2 inline-flex items-center gap-1 text-xs font-bold text-teal-600 dark:text-teal-400 hover:underline"
                >
                  <ExternalLink size={12} /> Ver painel completo
                </a>
              </div>
            </div>
          )
        ) : (
          isLoadingTecnoSpeed ? (
            <div className="space-y-6">
              {[1, 2, 3].map((i) => (
                <div key={i} className="animate-pulse rounded-3xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-5 space-y-4">
                  <div className="h-4 w-28 bg-gray-200 dark:bg-gray-700 rounded" />
                  <div className="h-6 w-52 bg-gray-200 dark:bg-gray-700 rounded" />
                  <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-9 gap-2">
                    {Array.from({ length: 18 }).map((_, index) => (
                      <div key={index} className="h-8 bg-gray-100 dark:bg-gray-700 rounded-xl" />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="space-y-6">
              {groupedTecnoSpeed.map((group) => {
                const groupPresentation = getTecnoSpeedStatusPresentation(group);
                const Icon = groupPresentation.icon;
                const stateTotals = group.states.reduce((accumulator, state) => {
                  if (state.severity === 'operational') accumulator.operational += 1;
                  else if (state.severity === 'outage') accumulator.stopped += 1;
                  else accumulator.attention += 1;
                  return accumulator;
                }, { operational: 0, attention: 0, stopped: 0 });

                return (
                  <div key={group.doc} className={`rounded-3xl border p-5 shadow-sm ${groupPresentation.bgClass}`}>
                    <div className="flex flex-wrap items-start justify-between gap-3">
                      <div className="min-w-0">
                        <p className="text-[10px] font-black uppercase tracking-widest text-gray-500 dark:text-gray-400">
                          {group.doc}
                        </p>
                        <h3 className="mt-1 text-base font-black text-gray-900 dark:text-white">
                          {group.doc === 'nfce' ? 'NFC-e' : group.doc === 'nfe' ? 'NF-e' : 'CT-e'}
                        </h3>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${groupPresentation.bgClass} ${groupPresentation.titleClass}`}>
                          {group.label}
                        </span>
                        <Icon className={`h-5 w-5 shrink-0 ${groupPresentation.iconClass}`} />
                      </div>
                    </div>

                    <div className="mt-4 grid gap-3 sm:grid-cols-3">
                      <div className="rounded-2xl border border-white/60 dark:border-white/10 bg-white/60 dark:bg-gray-800/30 px-3 py-2">
                        <p className="text-[9px] font-black uppercase tracking-widest text-gray-400">Normais</p>
                        <p className="mt-1 text-lg font-black text-emerald-600 dark:text-emerald-400">{stateTotals.operational}</p>
                      </div>
                      <div className="rounded-2xl border border-white/60 dark:border-white/10 bg-white/60 dark:bg-gray-800/30 px-3 py-2">
                        <p className="text-[9px] font-black uppercase tracking-widest text-gray-400">Atenção</p>
                        <p className="mt-1 text-lg font-black text-amber-600 dark:text-amber-400">{stateTotals.attention}</p>
                      </div>
                      <div className="rounded-2xl border border-white/60 dark:border-white/10 bg-white/60 dark:bg-gray-800/30 px-3 py-2">
                        <p className="text-[9px] font-black uppercase tracking-widest text-gray-400">Parados</p>
                        <p className="mt-1 text-lg font-black text-red-600 dark:text-red-400">{stateTotals.stopped}</p>
                      </div>
                    </div>

                    <div className="mt-4 flex flex-wrap gap-2">
                      {group.states.map((state) => {
                        const statePresentation = getTecnoSpeedStatusPresentation(state);

                        return (
                          <span
                            key={`${group.doc}-${state.uf}`}
                            title={`${state.uf}: ${statePresentation.title}`}
                            className={`inline-flex h-8 min-w-10 items-center justify-center rounded-xl border px-2 text-[10px] font-black uppercase tracking-widest ${statePresentation.bgClass} ${statePresentation.titleClass}`}
                          >
                            {state.uf}
                          </span>
                        );
                      })}
                    </div>

                    <div className="mt-4 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-dashed border-gray-200 dark:border-gray-700/50 px-3 py-2.5 text-[11px]">
                      <div>
                        <p className="font-black uppercase tracking-widest text-[9px] text-gray-400 dark:text-gray-500">
                          Referência MG
                        </p>
                        <p className="mt-1 font-bold text-gray-700 dark:text-gray-300">
                          {group.responseTimeMs != null ? `${group.responseTimeMs} ms` : 'Tempo não informado'}
                          {group.lastCheckedAt ? ` · ${new Date(group.lastCheckedAt).toLocaleString('pt-BR')}` : ''}
                        </p>
                      </div>
                      {group.source?.panelUrl ? (
                        <a
                          href={group.source.panelUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="shrink-0 inline-flex items-center gap-1 font-black uppercase tracking-widest text-[9px] text-teal-600 dark:text-teal-400 hover:text-teal-700 dark:hover:text-teal-300 transition-colors"
                        >
                          <ExternalLink size={10} /> Painel
                        </a>
                      ) : null}
                    </div>
                  </div>
                );
              })}

              {tecnoSpeedError && (
                <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
                  <div className="h-12 w-12 rounded-2xl bg-red-50 dark:bg-red-900/20 flex items-center justify-center mb-4">
                    <AlertCircle className="text-red-500" size={24} />
                  </div>
                  <h4 className="text-sm font-black text-gray-900 dark:text-white uppercase tracking-widest">Falha na Consulta</h4>
                  <p className="mt-2 text-xs text-gray-500 dark:text-gray-400 max-w-xs">
                    Não foi possível carregar os dados de monitoramento da TecnoSpeed no momento.
                  </p>
                </div>
              )}

              {groupedTecnoSpeed.length === 0 && !isLoadingTecnoSpeed && !tecnoSpeedError && (
                <div className="text-center py-12">
                  <p className="text-sm text-gray-500 dark:text-gray-400">Nenhum dado de monitoramento disponível.</p>
                </div>
              )}
            </div>
          )
        )}
      </div>
    </ModalShell>
  );
}
